// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pTq4","selected":"styles_selected__1i_-s"};